/**
 * Чистые правила разметки телеметрии: во что превращается маршрут и по чему
 * именно кликнули. Держим отдельно от хука, чтобы логику можно было проверять
 * без React и роутера — ошибиться здесь легко, а цена ошибки высокая: мусор в
 * аналитике выглядит как настоящие данные.
 */

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

/**
 * Сырой путь → шаблон маршрута: идентификаторы схлопываются в `:id`, иначе в
 * аналитике будет столько «экранов», сколько лекций и клиентов в системе.
 */
export function normalizeScreen(pathname: string): string {
  const parts = pathname.split('/').filter(Boolean)
  const normalized = parts.map((part) => {
    if (UUID_RE.test(part)) return ':id'
    if (/^\d+$/.test(part)) return ':id'
    // Длинный бессловесный ключ — тоже идентификатор.
    if (part.length > 20 && !part.includes('-')) return ':id'
    return part
  })
  return '/' + normalized.join('/')
}

/**
 * Ярлык кликнутого элемента. Приоритет — явный data-track (осмысленное имя),
 * дальше aria-label, дальше текст. Текст обрезаем и чистим от цифр: иначе
 * «Подход 3 из 4» породит десятки уникальных целей вместо одной.
 */
export function clickTarget(el: Element | null): string | null {
  const node = el?.closest<HTMLElement>('[data-track], button, a, [role="button"]')
  if (!node) return null

  const explicit = node.dataset.track
  if (explicit) return explicit.slice(0, 60)

  const label = node.getAttribute('aria-label')?.trim()
  if (label) return label.slice(0, 60)

  const text = node.textContent?.trim().replace(/\s+/g, ' ') ?? ''
  if (!text) {
    // Иконка без подписи — по тегу хотя бы понятно, что это была кнопка.
    return node.tagName.toLowerCase()
  }
  return text.replace(/\d+/g, 'N').slice(0, 60)
}
